/* Hello couleur — barre « Ajouter au panier » collante mobile (fiche produit).
   Port maquette (mockups/shared/product-sticky.js) adapte au DOM Liquid :
   - Bouton principal repere par [data-add-cart] (pas #add-cart-btn).
   - Variantes : [data-option-selector] (radios cachees, labels .variant-option).
   - Tap = submit du form (passe par le handler AJAX + toast deja en place). */
(function () {
  var btn = document.querySelector('[data-add-cart]');
  if (!btn) return;

  var titleEl = document.querySelector('.product__title');
  var priceEl = document.querySelector('[data-price-target]');

  var bar = document.createElement('div');
  bar.className = 'sticky-cart';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML =
    '<div class="sticky-cart__info">' +
    '<span class="sticky-cart__name"></span>' +
    '<span class="sticky-cart__price"></span>' +
    '</div>' +
    '<button type="button" class="btn btn-primary sticky-cart__btn">Ajouter au panier</button>';
  document.body.appendChild(bar);

  bar.querySelector('.sticky-cart__name').textContent = titleEl ? titleEl.textContent.trim() : 'Article';
  var sprice = bar.querySelector('.sticky-cart__price');

  function syncPrice() { sprice.textContent = priceEl ? priceEl.textContent.trim() : ''; }
  syncPrice();

  document.querySelectorAll('[data-option-selector]').forEach(function (radio) {
    radio.addEventListener('change', function () { setTimeout(syncPrice, 0); });
  });

  bar.querySelector('.sticky-cart__btn').addEventListener('click', function () {
    syncPrice();
    if (btn.disabled) return;
    var form = btn.closest('form');
    if (form && typeof form.requestSubmit === 'function') {
      form.requestSubmit(btn);
    } else {
      btn.click();
    }
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      var hidden = !entries[0].isIntersecting;
      bar.classList.toggle('sticky-cart--show', hidden);
      bar.setAttribute('aria-hidden', hidden ? 'false' : 'true');
    }, { threshold: 0 });
    io.observe(btn);
  } else {
    bar.classList.add('sticky-cart--show');
  }
})();
